// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2U9p5","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__RC-tj"};